var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepSim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Subtract",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3584_46665",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V22.323C0 23.3839 0.421427 24.4013 1.17157 25.1514L6.84857 30.8284C7.59872 31.5786 8.61613 32 9.677 32H28C30.2091 32 32 30.2091 32 28V4C32 1.79086 30.2091 0 28 0H4Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.84857 30.8284L7.55568 30.1213L6.84857 30.8284ZM1.17157 25.1514L0.464466 25.8585L1.17157 25.1514ZM1 4C1 2.34315 2.34315 1 4 1V-1C1.23858 -1 -1 1.23858 -1 4H1ZM1 22.323V4H-1V22.323H1ZM0.464466 25.8585L6.14147 31.5355L7.55568 30.1213L1.87868 24.4443L0.464466 25.8585ZM28 31H9.677V33H28V31ZM31 28C31 29.6569 29.6569 31 28 31V33C30.7614 33 33 30.7614 33 28H31ZM31 4V28H33V4H31ZM28 1C29.6569 1 31 2.34315 31 4H33C33 1.23858 30.7614 -1 28 -1V1ZM4 1H28V-1H4V1ZM6.14147 31.5355C7.07915 32.4732 8.35092 33 9.677 33V31C8.88135 31 8.11829 30.6839 7.55568 30.1213L6.14147 31.5355ZM-1 22.323C-1 23.6491 -0.473216 24.9209 0.464466 25.8585L1.87868 24.4443C1.31607 23.8817 1 23.1187 1 22.323H-1Z",
    fill: "#FDEE2D",
    mask: "url(#path-1-inside-1_3584_46665)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepSim);
export default __webpack_public_path__ + "static/media/step-sim.29d169a41c6836e7822eae55d9c3f129.svg";
export { ForwardRef as ReactComponent };